const DOMAIN_PREFIX = {
    dev: 't-dtap.',
    tst: 't-dtap.',
    acc: 'a-dtap.',
    prd: '',
};

export const domainPrefix = DOMAIN_PREFIX[process.env.APP_ENV || 'dev'];
